export default __webpack_public_path__ + "static/media/discord.0628da0f.svg";